<template>
  <main class="page">
    <section class="section page__header">
      <div class="page__row">
        <div class="page__item">
          <h1 class="title">Мои сотрудники</h1>
        </div>
      </div>
    </section>

    <section class="section page__content">
      <div class="sub-departments-wrap" v-if="subDepartments.length !== 0">
        <div class="sub-department mb-40" v-for="department in subDepartments" :key="department.id">
          <div class="subtitle mb-20">{{ department.name }}</div>
          <div class="card-list" v-if="department.users.length !== 0">
            <div class="card-item" v-for="user in department.users" :key=user.id>
              <SubordinateUserCard :user="user"
                                   @update-status="updateStatus"
                                   @show-transfer-modal="showUserTransferModal"
              />
            </div>
          </div>
          <div class="tip-text" v-else>В этом подразделении нет сотрудников</div>
        </div>
      </div>
      <div class="page__row mb-20"  v-else>
        <div class="no-records">
          <AppNoRecordsPlaceholder text="Нет сотрудников в подчинении"/>
        </div>
      </div>
    </section>

    <section class="section page__footer user-list__footer">
    </section>

    <transition name="fade">
      <UserTransferModal v-if="transferModal.active"
                         :state="transferModal"
                         @toggle-transfer-status="toggleUserTransferStatus"
                         @set-transfer-comment="setUserTransferComment"
                         @update-transfer-info="updateUserTransferInfo"
                         @close-modal="closeUserTransferModal"
      />
    </transition>
    <ThePagePreloader v-if="pageIsLoading"/>
  </main>
</template>

<script>
import ThePagePreloader from '../../components/page/ThePagePreloader'
import AppNoRecordsPlaceholder from '../../components/page/text/AppNoRecordsPlaceholder'
import SubordinateUserCard from '@/components/page/user/SubordinateUserCard'
import UserTransferModal from '@/components/page/modal/UserTransferModal'

export default {
  name: 'SubordinatesList',
  components: {
    UserTransferModal,
    SubordinateUserCard,
    AppNoRecordsPlaceholder,
    ThePagePreloader
  },
  data () {
    return {
      removeConfirmation: {
        active: false,
        userId: null
      }
    }
  },
  computed: {
    subDepartments () {
      return this.$store.getters.subordinatesListDepartments
    },
    transferModal () {
      return this.$store.getters.subordinatesListTransferModal
    },
    pageIsLoading () {
      return this.$store.getters.subordinatesListPageIsLoading
    },

    currentUser () {
      return this.$store.getters.currentUser
    }
  },
  methods: {
    updateStatus (data) {
      this.$store.dispatch('updateUserSubordinateStatus', data)
    },
    showUserTransferModal (userId) {
      this.$store.dispatch('showSubordinateTransferModal', userId)
    },
    toggleUserTransferStatus () {
      this.$store.dispatch('toggleUserSubordinateTransferStatus')
    },
    setUserTransferComment (comment) {
      this.$store.dispatch('setUserSubordinateTransferComment', comment)
    },
    updateUserTransferInfo () {
      this.$store.dispatch('updateUserSubordinateTransferInfo')
    },
    closeUserTransferModal () {
      this.$store.dispatch('closeSubordinateTransferModal')
    }
  },
  mounted () {
    const userId = this.$route.params.id
    this.$store.dispatch('getUserSubordinates', userId)

    // TODO: иногда при обновлении страницы или лайв релоада компонент ломается "cannot read name of undefined", возможно из-за загрузки списков
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.user-list {
  &__footer {
    padding-bottom: 110px;
  }
}

.card-list {
  display: flex;
  flex-flow: row wrap;
}

.card-item {
  margin-right: 32px;
  margin-bottom: 32px;
}

.tip-text {
  color: $font_color_second;
}

.no-records {
  width: 100%;
  margin-top: 80px;
}
</style>
